<!-- Nova tela de complementos (flag: new_complements_pedir_delivery)-->
<ng-container *ngIf="isNewComplementsPedirDelivery">
    <div class="complements" [class.new-design-font]="isNewComplementsPedirDelivery">

        <div class="complements__sticky-header" #stickyHeader>
            <span class="complements__header-btn complements__header-btn--ghost" aria-hidden="true"></span>
            <p class="complements__header-title">{{item.name}}</p>
            <button class="complements__header-btn" (click)="back()" aria-label="Fechar">
                <img src="assets/icon/close-x.svg" aria-hidden="true">
            </button>
        </div>

        <div class="complements__body" #complementsBody>

            <app-image-item-expansive
                *ngIf="item.image"
                #imageWrap
                [src]="imgURL + '/products/' + item.image + '/lg_' + item.image + '.jpg'"
                [alt]="item.name"
                (closed)="back()"
            ></app-image-item-expansive>
            <div *ngIf="!item.image" class="complements__header-no-image" #noImageHeader>
                <span class="complements__header-btn complements__header-btn--ghost" aria-hidden="true"></span>
                <p class="complements__header-title">{{item.name}}</p>
                <button class="complements__header-btn" (click)="back()" aria-label="Fechar">
                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L12 12M12 1L1 12" stroke="#656F77" stroke-width="1.5" stroke-linecap="round"/>
                    </svg>
                </button>
            </div>

            <div class="complements__product-info">
                <h2 class="complements__product-name">{{item.name}}</h2>
                <p *ngIf="item.description" class="complements__product-desc">
                    <span *ngIf="isInstagram()">{{removeHtmlTags(item.description)}}</span>
                    <span *ngIf="!isInstagram()" [innerHTML]="getSafeHtml(item.description)"></span>
                </p>
                <p *ngIf="item.price > 0 && !item.fromPrice" class="complements__product-price">{{item.price | multiCurrency}}</p>
                <p *ngIf="item.fromPrice" class="complements__product-price complements__product-price--from">
                    {{'From_price' | translate}} {{item.fromPrice | multiCurrency}}
                </p>
            </div>

            <div
                *ngFor="let itemExtra of extras; let extraIndex = index"
                class="complements__group"
                [id]="'extra-v2-' + itemExtra.id"
            >
                <div class="complements__group-header">
                    <div class="complements__group-header-info">
                        <p class="complements__group-name">{{itemExtra.name}}</p>
                        <p *ngIf="itemExtra.description" class="complements__group-desc">
                            <span *ngIf="isInstagram()">{{removeHtmlTags(itemExtra.description)}}</span>
                            <span *ngIf="!isInstagram()" [innerHTML]="getSafeHtml(itemExtra.description)"></span>
                        </p>
                    </div>
                    <div class="complements__group-tags">
                        <!-- Badge contador: cinza = requisito não atingido, verde = satisfeito -->
                        <span
                            *ngIf="itemExtra.type == 1"
                            class="complements__tag"
                            [class.complements__tag--counter]="!isGroupSatisfied(itemExtra)"
                        >
                            {{ (itemExtra.radioGroup && itemExtra.radioGroup !== 0) ? 1 : 0 }}/1
                        </span>
                        <span
                            *ngIf="itemExtra.type != 1"
                            class="complements__tag"
                            [class.complements__tag--counter]="!isGroupSatisfied(itemExtra)"
                        >
                            {{ itemExtra.qty || 0 }}/{{ itemExtra.qty_max }}
                        </span>

                        <!-- Mínimo > 1 apenas para tipos múltiplos → "Obrigatório • Mínimo N" -->
                        <span
                            *ngIf="itemExtra.qty_min > 1 && itemExtra.type != 1"
                            class="complements__tag"
                            [class.complements__tag--counter]="!isGroupSatisfied(itemExtra)"
                        >Obrigatório <b>•</b> Mínimo {{itemExtra.qty_min}}</span>

                        <!-- Obrigatório: radio obrigatório OU múltiplo com mínimo exatamente 1 -->
                        <span
                            *ngIf="(itemExtra.type == 1 && itemExtra.required) || (itemExtra.type != 1 && itemExtra.qty_min == 1)"
                            class="complements__tag"
                            [class.complements__tag--counter]="!isGroupSatisfied(itemExtra)"
                            translate
                        >Mandatory</span>
                    </div>
                </div>

                <div class="complements__options-container">
                    <ng-container *ngFor="let option of itemExtra.options; let optionIndex = index">
                        <div *ngIf="option.asTitle" class="complements__option-title">
                            {{option.name}}
                        </div>
                        <div
                            *ngIf="!option.asTitle && (option.available && option.hasStock === true || option.hasStock === false && showStockPausedItems())"
                            class="complements__option"
                            [class.complements__option--unavailable]="option.hasStock === false"
                            [class.complements__option--selected]="option.qty > 0 || option.isChecked || option.id == itemExtra.radioGroup"
                            (click)="firstIncrementNew(extraIndex, optionIndex)"
                        >
                            <img
                                *ngIf="option.image"
                                class="complements__option-img"
                                [src]="imgURL + '/products/' + option.image + '/thumb_' + option.image + '.jpg'"
                                [alt]="option.name"
                                (error)="onImgError(option)"
                                (click)="openViewer(option); $event.stopPropagation()"
                            />

                            <div class="complements__option-info">
                                <p class="complements__option-name">{{option.name}}</p>
                                <p *ngIf="option.description" class="complements__option-desc">
                                    <span *ngIf="isInstagram()">{{removeHtmlTags(option.description)}}</span>
                                    <span *ngIf="!isInstagram()" [innerHTML]="getSafeHtml(option.description)"></span>
                                </p>
                                <p *ngIf="option.price > 0" class="complements__option-price">+ {{option.price | multiCurrency}}</p>
                            </div>

                            <div
                                *ngIf="itemExtra.type == 1"
                                class="complements__option-radio"
                                [class.complements__option-radio--active]="option.id == itemExtra.radioGroup"
                            ></div>

                            <div
                                *ngIf="(itemExtra.type == 2 && itemExtra.qty_max != 1) || (itemExtra.type == 3 && itemExtra.qtyPerItem > 1)"
                                class="complements__option-counter"
                                (click)="$event.stopPropagation()"
                            >
                                <ng-container *ngIf="option.qty > 0">
                                    <button
                                        class="complements__counter-opt complements__counter-opt--minus"
                                        (click)="decrementQty(extraIndex, optionIndex, $event)"
                                        aria-label="Diminuir"
                                    ><span class="complements__counter-icon complements__counter-icon--minus"></span></button>
                                    <!-- OP-1108: quantidade digitável, como na tela antiga. Ligação em um
                                         sentido só + (change) — que dispara no blur/Enter — para o modelo
                                         não mudar a cada tecla e desmontar o campo ao apagá-lo.
                                         O (input) apaga o que não é dígito na hora e já grava a
                                         quantidade: no celular o toque em "Adicionar" não blura o
                                         campo, então esperar o (change) mandava 1x para o carrinho. -->
                                    <input
                                        class="complements__counter-num complements__counter-input"
                                        type="text"
                                        inputmode="numeric"
                                        [ngModel]="option.qty"
                                        [disabled]="!option.hasStock"
                                        (focus)="$event.target.select()"
                                        (input)="onQuantityInput(extraIndex, optionIndex, $event)"
                                        (change)="setInputQuantity(extraIndex, optionIndex, $event.target.value)"
                                        [attr.aria-label]="'Quantidade de ' + option.name"
                                        data-cy="complementQtyInput" />
                                </ng-container>
                                <button
                                    class="complements__counter-opt complements__counter-opt--plus"
                                    [class.complements__counter-opt--at-max]="extras[extraIndex].qty >= extras[extraIndex].qty_max || (extras[extraIndex].qtyPerItem && option.qty >= extras[extraIndex].qtyPerItem)"
                                    [disabled]="!option.hasStock"
                                    (click)="incrementQty(extraIndex, optionIndex); $event.stopPropagation()"
                                    aria-label="Adicionar"
                                ><span class="complements__counter-icon complements__counter-icon--plus"></span></button>
                            </div>

                            <div
                                *ngIf="isSingleSelectToggle(itemExtra)"
                                class="complements__option-checkbox"
                                [class.complements__option-checkbox--active]="option.isChecked"
                                [class.complements__option-checkbox--disabled]="itemExtra.qty_max != 1 && !option.isChecked && checkboxBeyondLimit(extraIndex)"
                            >
                                <span *ngIf="option.isChecked" class="complements__option-checkbox-icon"></span>
                            </div>

                            <span *ngIf="!option.hasStock" class="complements__option-stock-badge" data-cy="hasStock">Indisponível</span>
                        </div>
                    </ng-container>
                </div>
            </div>

            <div *ngIf="allowNotes" class="complements__obs">
                <div class="complements__obs-header">
                    <span translate class="complements__obs-header-title">Some observation<span>?</span></span>
                    <span>{{observation.length}}/100</span>
                </div>
                <textarea
                    class="complements__obs-textarea"
                    [(ngModel)]="observation"
                    maxlength="100"
                    placeholder="Ex.: Retirar a salada, bacon à parte, etc."
                ></textarea>
            </div>

        </div>

        <app-complements-footer
            [item]="item"
            [selectedExtras]="getSelectedExtras()"
            [itemQty]="itemQty"
            [stepPrice]="calculateTotalPrice() * itemQty"
            [totalPrice]="combo ? (combo.totalPrice + calculateTotalPrice()) : (calculateTotalPrice() * itemQty)"
            [disabled]="isDisabled()"
            [showCounter]="!combo"
            [showCartIcon]="!combo"
            [buttonLabel]="combo ? 'Próximo' : 'Adicionar'"
            (action)="addToShoppingCart()"
            (blockedAction)="onBlockedAction()"
            (increment)="incrementItemQty()"
            (decrement)="decrementItemQty()"
        ></app-complements-footer>

    </div>
</ng-container>

<!-- Layout antigo (Ionic) – ativo quando new_complements_pedir_delivery NÃO está habilitado -->
<ng-container *ngIf="!isNewComplementsPedirDelivery">
    <ion-header>
        <ion-toolbar color="danger">
            <ion-buttons slot="start">
                <ion-button (click)="back()">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </ion-button>
            </ion-buttons>
            <ion-title class="p-2 ion-text-center">{{item.name}}</ion-title>
            <!-- Espaçador invisível espelhando o botão voltar p/ centralizar o
                 título na largura cheia (paridade com pizza/pizza-nep). -->
            <ion-buttons slot="end" aria-hidden="true">
                <ion-button style="visibility:hidden;pointer-events:none">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </ion-button>
            </ion-buttons>
        </ion-toolbar>
    </ion-header>

    <ion-content style="display: flex">
        <ion-list *ngFor="let itemExtra of extras; let extraIndex = index" [id]="'extra-'+itemExtra.id">
            <ion-radio-group [(ngModel)]="itemExtra.radioGroup">
                <ion-list-header class="ion-no-padding ion-text-center">
                    <ion-title class="p-2" size="small">
                        <h3>{{itemExtra.name}}</h3>
                        <ion-row *ngIf="itemExtra.description">
                            <ion-col>
                                <ion-card color="light" class="ion-no-margin ion-margin-bottom">
                                    <ion-card-content *ngIf="isInstagram()" class="text-wrap">{{removeHtmlTags(itemExtra.description)}}</ion-card-content>
                                    <ion-card-content *ngIf="!isInstagram()"><span [innerHTML]="getSafeHtml(itemExtra.description)"></span></ion-card-content>
                                </ion-card>
                            </ion-col>
                        </ion-row>

                        <ion-text *ngIf="itemExtra.type != 1"> <span translate>Min</span>: {{itemExtra.qty_min}} | <span translate>Max</span>: {{itemExtra.qty_max}} </ion-text>

                        <ion-text *ngIf="itemExtra.required || (itemExtra.type != 1 && itemExtra.qty_min > 0)">
                            <p translate>Mandatory</p>
                        </ion-text>
                    </ion-title>
                </ion-list-header>

                <span *ngFor="let item of itemExtra.options; let optionIndex = index">
                    <ion-item
                        *ngIf="item.available && item.hasStock === true || item.hasStock === false && showStockPausedItems()"
                        lines="inset"
                        (click)="firstIncrement(extraIndex, optionIndex)"
                        class="ion-activatable"
                        [ngClass]="{'extra-extra__without-stock' : item.hasStock === false}"
                        style="position: relative"
                        [color]="item.qty > 0 ? 'danger' : ''"
                    >
                        <!-- OP-1110: sem estoque o clique é bloqueado em firstIncrement(),
                             então o ripple prometia uma ação que não acontece. -->
                        <ion-ripple-effect *ngIf="!item.asTitle && item.hasStock !== false"></ion-ripple-effect>
                        <ion-grid [ngClass]="{ 'unavailable': !item.hasStock }">
                            <ion-row *ngIf="item.asTitle">
                                <ion-col>
                                    <ion-text class="ion-text-center ion-text-wrap"> <h3>{{item.name}}</h3> </ion-text>
                                </ion-col>
                            </ion-row>

                            <ion-row *ngIf="!item.asTitle" class="ion-align-items-stretch">
                                <ion-col size="3" class="p-0 centralize" *ngIf="item.image">
                                    <mp-img
                                        class="item-image"
                                        imgURL="{{imgURL}}/products/{{item.image}}/thumb_{{item.image}}.jpg"
                                        (error)="onImgError(item)"
                                        (click)="openViewer(item); $event.stopPropagation();"
                                    ></mp-img>
                                </ion-col>

                                <ion-col [size]="item.image ? 5 : 8">
                                    <div class="text-wrap">
                                        {{item.name}}
                                        <br />
                                        <label *ngIf="item.description" class="text-wrap" style="line-height: 1">
                                            <small *ngIf="isInstagram()">{{removeHtmlTags(item.description)}}</small>
                                            <small *ngIf="!isInstagram()" [innerHTML]="getSafeHtml(item.description)"></small>
                                        </label>

                                        <ion-label *ngIf="item.price > 0" [ngClass]="{'extra-price-active': item.qty > 0, 'extra-price-label': item.qty <= 0}">
                                            <b> {{item.price | multiCurrency}} </b>
                                        </ion-label>
                                    </div>
                                </ion-col>

                                <ion-col size="4">
                                    <ion-radio color="light" [disabled]="!item.hasStock" *ngIf="itemExtra.type == 1" [value]="item.id" class="ion-float-right"></ion-radio>

                                    <span *ngIf="(itemExtra.type == 2 && itemExtra.qty_max != 1) || (itemExtra.type == 3 && itemExtra.qtyPerItem > 1)" class="ion-float-right">
                                        <ion-row>
                                            <ion-icon
                                                name="remove-outline"
                                                [hidden]="item.qty == 0"
                                                class="quantity-button"
                                                style="font-size: 25px"
                                                (click)="decrementQty(extraIndex, optionIndex, $event)"
                                                [class.white-quantity-button]="item.qty > 0"
                                            ></ion-icon>
                                            <ion-input
                                                #ionicInput
                                                type="number"
                                                [disabled]="!item.hasStock"
                                                [hidden]="item.qty == 0"
                                                inputmode="number"
                                                class="text-center extra-input-quantity"
                                                [(ngModel)]="item.qty"
                                                (ionChange)="changeInputQuantity(itemExtra, item)"
                                            ></ion-input>
                                            <ion-icon
                                                name="add-outline"
                                                class="quantity-button"
                                                style="font-size: 25px"
                                                (click)="incrementQty(extraIndex, optionIndex)"
                                                [class.white-quantity-button]="item.qty > 0"
                                            ></ion-icon>
                                        </ion-row>
                                    </span>

                                    <span *ngIf="isSingleSelectToggle(itemExtra)" class="ion-float-right">
                                        <!-- MP-521: o checkbox é só o indicador visual da seleção. Quem trata o
                                             clique é o ion-item (que envolve a linha inteira, checkbox incluso).
                                             Com um (click) aqui também, o clique na caixa disparava
                                             firstIncrement() duas vezes — uma no checkbox, outra no item por
                                             bubbling — e o toggle se anulava: caixa marcada, complemento não
                                             selecionado. Por isso [checked] (leitura) e não [(ngModel)]. -->
                                        <ion-checkbox
                                            color="light"
                                            [checked]="item.isChecked"
                                            [disabled]="(itemExtra.qty_max != 1 && !item.isChecked && checkboxBeyondLimit(extraIndex)) || !item.hasStock"
                                        ></ion-checkbox>
                                    </span>
                                </ion-col>
                            </ion-row>
                            <ion-badge *ngIf="!item.hasStock" data-cy="hasStock">Item indisponível no momento.</ion-badge>
                        </ion-grid>
                    </ion-item>
                </span>
            </ion-radio-group>
        </ion-list>
    </ion-content>

    <ion-footer color="">
        <!-- Resumo como overlay ancorado acima do rodapé: fora do fluxo para o
             ion-footer manter altura constante — redimensionar o container de
             scroll dispara o bug de re-clamp do scroll no iOS/WebKit -->
        <div class="footer-summary-overlay" appOverlayScrollPadding>
            <ion-grid style="padding-right: 0px">
                <ion-row *ngIf="item.price > 0">
                    <ion-col size="9">
                        <span class="vertical-align-selected-flavors">
                            <strong>{{(item.name.length>20)? (item.name | slice:0:20)+'...':(item.name)}}</strong>
                        </span>
                    </ion-col>

                    <ion-col size="3" style="text-align: right">
                        <span class="vertical-align-selected-flavors">
                            <strong>{{item.price | multiCurrency}}</strong>
                        </span>
                    </ion-col>
                </ion-row>

                <ion-row *ngFor="let extra of getSelectedExtras()">
                    <ion-col size="9">
                        <span class="vertical-align-selected-flavors">
                            <b *ngIf="extra.qty > 1">{{extra.qty}}x</b>
                            {{(extra.name.length>20)? (extra.name | slice:0:20)+'...':(extra.name)}}
                        </span>
                    </ion-col>

                    <ion-col size="3" style="text-align: right">
                        <span class="vertical-align-selected-flavors" *ngIf="extra.total > 0"> {{extra.price * extra.qty | multiCurrency}} </span>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </div>

        <ion-toolbar>
            <ion-grid>
                <ion-row class="ion-text-center footerButton">
                    <ion-col>
                        <ion-label *ngIf="selectedExtras.length > 0" style="position: relative; top: 10px">
                            <ion-text translate>TOTAL: </ion-text>
                            <ion-text style="font-weight: bold !important">{{calculateTotalPrice() | multiCurrency}} </ion-text>
                        </ion-label>
                    </ion-col>

                    <ion-col>
                        <ion-button color="danger" expand="block" mode="ios" class="ion-no-margin" (click)="addToShoppingCart()" [disabled]="isDisabled()" data-cy="extraAdd">
                            <ion-text style="font-weight: 800; font-size: 0.9em" translate><ion-icon name="cart-outline" style="margin-right: 4px"></ion-icon> ADD TO CART</ion-text>
                        </ion-button>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-toolbar>
    </ion-footer>
</ng-container>
